export const GUIDELINE_PDF_CLICKED = 'GUIDELINE_PDF_CLICKED';
export const LANDING_VIDEO_PLAYED = 'LANDING_VIDEO_PLAYED';
export const LOG_USER_ACTION = 'LOG_USER_ACTION';
export const GA_PARTNER_ID_RECEIVED = 'GA_PARTNER_ID_RECEIVED';
export const GA_PARTNER_ID_FETCH_FAILED = 'GA_PARTNER_ID_FETCH_FAILED';

export function guidelinePdfClicked() {
  return {
    type: GUIDELINE_PDF_CLICKED,
  };
}

export function landingVideoPlayed() {
  return {
    type: LANDING_VIDEO_PLAYED,
  };
}

export function logUserAction({ category, label, params }) {
  return {
    type: LOG_USER_ACTION,
    payload: {
      category,
      label,
      params,
    },
  };
}

export function setPartnerId({ partnerId }) {
  return {
    type: GA_PARTNER_ID_RECEIVED,
    payload: {
      partnerId,
    },
  };
}

export function fetchPartnerIdFailed(err) {
  return {
    type: GA_PARTNER_ID_FETCH_FAILED,
    err,
  };
}



// WEBPACK FOOTER //
// ./src/actions/analytics.js